module.exports = __webpack_public_path__ + "static/img/j4.94a7ebf2.jpg";